export default __webpack_public_path__ + "static/media/down-red.76d2accd.svg";